export default __webpack_public_path__ + "static/media/flag001.5a8d2fbe.png";